import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/router/ScrollToTop';
import { configureAmplify } from './cognito';
import { initializeAnalytics } from './analytics/analytics';
import config from './config';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

configureAmplify(config.cognito);
initializeAnalytics(config.analytics.trackingId);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
